export const ALLOWED_PHOTO_EXTENSIONS = [
    "jpg",
    "jpeg",
    "png",
    "webp",
    "heic",
    "heif",
];
export const ALLOWED_VIDEO_EXTENSIONS = ["mp4", "mov", "webm", "m4v"];
export const ALLOWED_EXTENSIONS = [
    ...ALLOWED_PHOTO_EXTENSIONS,
    ...ALLOWED_VIDEO_EXTENSIONS,
];
/**
 * MIME types accepted per detected file-type (magic bytes), keyed by the
 * extension the file is stored under. Multiple MIME strings can map to the
 * same extension (e.g. browsers disagree on the exact video/quicktime vs
 * video/mp4 string for .mov).
 */
export const ALLOWED_MIME_TYPES = {
    jpg: ["image/jpeg"],
    jpeg: ["image/jpeg"],
    png: ["image/png"],
    webp: ["image/webp"],
    heic: ["image/heic", "image/heif"],
    heif: ["image/heic", "image/heif"],
    mp4: ["video/mp4"],
    mov: ["video/quicktime", "video/mp4"],
    webm: ["video/webm"],
    m4v: ["video/mp4", "video/x-m4v"],
};
export const PHOTO_EXTENSIONS_SET = new Set(ALLOWED_PHOTO_EXTENSIONS);
export const VIDEO_EXTENSIONS_SET = new Set(ALLOWED_VIDEO_EXTENSIONS);
export const DEFAULT_MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024 * 1024; // 2GB
export const DEFAULT_MAX_FILES_PER_UPLOAD = 100;
export const DEFAULT_MAX_CONCURRENT_UPLOADS = 5;
export const DEFAULT_THUMBNAIL_WIDTH = 480;
export const DEFAULT_VIDEO_THUMB_OFFSET_SECONDS = 1;
export const DEFAULT_UPLOAD_RATE_LIMIT = 20;
export const DEFAULT_AUTH_RATE_LIMIT = 10;
export const DEFAULT_API_RATE_LIMIT = 100;
export const SESSION_COOKIE_NAME = "event_session";
export const ADMIN_SESSION_COOKIE_NAME = "admin_session";
export const STORAGE_API_SECRET_HEADER = "x-storage-api-secret";
export const DEFAULT_MEDIA_PAGE_SIZE = 60;
//# sourceMappingURL=constants.js.map